/* Cuvée — cart-line variant-title sanitizer.
 *
 * The cart drawer (cart-components.js) and ATC notification (CartNotification class)
 * write `cart_item.variant_title` directly into the property-value element. For
 * test arm variants this looks like "5 oz / P24" — we want it to read just "5 oz".
 *
 * Server-side cart-item.liquid handles initial renders; this module handles the
 * JS-driven re-renders. Loads globally via layout/theme.liquid.
 *
 * (2026-05-04)
 */
(function () {
  'use strict';

  // Suffix patterns the Cuvée Price Test produces on variant titles. Match any
  // " / Standard" or " / P<digits>" tail, plus the case where the title IS just
  // a test arm value (rare — single-option products).
  // Single replacement loop catches both " / X" and bare "X" forms.
  function sanitize(text) {
    if (typeof text !== 'string' || !text) return text;
    var cleaned = text;
    // Strip a trailing " / Standard" or " / P{n}"
    cleaned = cleaned.replace(/\s*\/\s*(Standard|P\d+)\s*$/i, '');
    // If after that the whole thing is just "Standard" / "P19", drop it (no subtitle)
    if (/^(Standard|P\d+)$/i.test(cleaned.trim())) cleaned = '';
    return cleaned.trim();
  }

  // Apply the sanitizer to a single element's text/HTML if it looks like a variant title.
  function cleanNode(el) {
    if (!el) return;
    var raw = el.innerHTML;
    var clean = sanitize(raw);
    if (clean !== raw) {
      if (clean === '') {
        // Hide the whole property-value row if it ended up empty (the parent dt/dd pair)
        var parent = el.closest('cart-item-default-property, .cart-meta');
        if (parent) parent.style.display = 'none';
      } else {
        el.innerHTML = clean;
      }
    }
  }

  // Walk every property-value inside cart-related containers and clean
  function sweep(root) {
    (root || document).querySelectorAll(
      'cart-item-default-property property-value, ' +
      '.cart-item-default-property property-value, ' +
      'cart-notification cart-item-default-property property-value'
    ).forEach(cleanNode);
  }

  // Initial sweep + observer for future mutations
  function init() {
    sweep(document);
    var targets = document.querySelectorAll(
      'interactive-cart, cart-drawer, cart-notification, cart-items, [drawer-cart], #drawer-cart, .cart--draw'
    );
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1) {
            cleanNode(n);
            sweep(n);
          }
        });
        if (m.type === 'characterData' && m.target && m.target.parentElement) {
          cleanNode(m.target.parentElement);
        }
      });
    });
    if (targets.length === 0) {
      // Fallback: observe the body for late-arriving cart elements
      observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    } else {
      targets.forEach(function (t) {
        observer.observe(t, { childList: true, subtree: true, characterData: true });
      });
      // Also still observe body for cart elements added later
      observer.observe(document.body, { childList: true, subtree: false });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
